export enum Environment {
  PROD = 'prod',
  STAGING = 'staging',
  PROD_PAPER = 'prod-ppr',
}
